import { Moment } from "moment-timezone";

// The bucket granularity the main log-stats bars use (LogStatsView `Stats`), as
// Dataload::Logs.log_stats_sql buckets them.
export function logStatsBucketMinutes(from: Moment, to: Moment): number {
  if (to.diff(from, "hours", true) <= 3) {
    return 1;
  }
  if (to.diff(from, "days", true) <= 3) {
    return 10;
  }
  return 60;
}

// The bucket granularity of the W40/S7 analysis bars, as
// Dataload::Logs.detail_log_stats_for_classification buckets them.
export function logAnalysisBucketMinutes(from: Moment, to: Moment): number {
  return to.diff(from, "days", true) <= 3 ? 10 : 60;
}
